import { UserPasskeysViewModel } from '@apis/model';
import { UserPasskeyResponse } from '@ul/api';

export const toUserPasskeysViewModel = (response: UserPasskeyResponse): UserPasskeysViewModel | undefined => {
    if (response?.passkeys) {
        return {
            responseCode: response.responseCode,
            success: response.success,
            passkeys: response.passkeys,
        };
    }
    return undefined;
};
